import { render } from "./PlayersListDraftTeam.vue?vue&type=template&id=094be944&scoped=true"
import script from "./PlayersListDraftTeam.vue?vue&type=script&lang=js"
export * from "./PlayersListDraftTeam.vue?vue&type=script&lang=js"

import "./PlayersListDraftTeam.vue?vue&type=style&index=0&id=094be944&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-094be944"]])

export default __exports__